import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { fieldTemplatesActions } from '../../../../store';

import type { AppDispatch, RootState } from '../../../../store';

// Wraps the field-templates Redux reads/dispatches so the page never touches
// react-redux or the slice directly.
export const useFieldTemplates = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();

  const fields = useSelector((s: RootState) => s.fieldTemplates.fields);
  const fieldsLoading = useSelector((s: RootState) => s.fieldTemplates.fieldsLoading);
  const fieldTemplate = useSelector((s: RootState) => s.fieldTemplates.fieldTemplate);
  const fieldTemplateLoading = useSelector((s: RootState) => s.fieldTemplates.fieldTemplateLoading);
  const updateFieldTemplateLoading = useSelector(
    (s: RootState) => s.fieldTemplates.updateFieldTemplateLoading,
  );

  const loadFields = useCallback(
    () =>
      dispatch(
        fieldTemplatesActions.getFields({
          resource: '',
          withTemplate: true,
          getAccessTokenSilently,
        }),
      ),
    [dispatch, getAccessTokenSilently],
  );

  const loadTemplate = useCallback(
    (identifier: string) =>
      dispatch(fieldTemplatesActions.getByIdentifier({ identifier, getAccessTokenSilently })),
    [dispatch, getAccessTokenSilently],
  );

  const saveTemplate = useCallback(
    (identifier: string, content: string) =>
      dispatch(
        fieldTemplatesActions.updateByIdentifier({
          identifier,
          data: { content },
          getAccessTokenSilently,
        }),
      ),
    [dispatch, getAccessTokenSilently],
  );

  return {
    fields,
    fieldsLoading,
    fieldTemplate,
    fieldTemplateLoading,
    updateFieldTemplateLoading,
    loadFields,
    loadTemplate,
    saveTemplate,
  };
};
